import JobAdWindow from 'module/recruitment/pages/recruitment-create-job-ad/components/JobAdWindow'
import { useState } from 'react'
import { useMutation, useQueryClient } from 'react-query'
import { createJobPosting } from 'services/api/modules/recruitment/job-advertisment'

const CreateJobAd = () => {
  const [typeOfForm, setTypeOfForm] = useState('')
  const [loading, setLoading] = useState(false)
  const [success, setSuccess] = useState(false)

  // API
  const queryClient = useQueryClient()
  const {
    mutate: createJobPostingPublish,
    isError: createJobPostingPublishError,
    isSuccess: createJobPostingPublishIsSuccess,
    isLoading: createJobPostingPublishisLoading,
  } = useMutation((value) => createJobPosting('publish', value), {
    onSuccess: (response) => {
      console.log(response)
    },
    onError: (error) => {
      console.log(error)
    },
  })
  const {
    mutate: createJobPostingDraft,
    isError: createJobPostingErrorDraft,
    isSuccess: createJobPostingDraftIsSuccess,
    isLoading: createJobPostingDraftisLoading,
  } = useMutation((value) => createJobPosting('draft', value), {
    onSuccess: (response) => {
      console.log(response)
    },
    onError: (error) => {
      console.log(error)
    },
  })

  const handleTypeOfForm = (data) => {
    setTypeOfForm(data)
  }
  const handleSubmit = (e) => {
    if (typeOfForm === 'publish') {
      createJobPostingPublish(e)
      setLoading(createJobPostingPublishisLoading)
      setSuccess(createJobPostingPublishIsSuccess)
    } else if (typeOfForm === 'draft') {
      createJobPostingDraft(e)
      setLoading(createJobPostingDraftisLoading)
      setSuccess(createJobPostingDraftIsSuccess)
    }
  }

  // WILL REFACTOR THIS LEGACY CODE SOON!!! !reminder(afi)

  return (
    <JobAdWindow
      onSubmit={handleSubmit}
      handleTypeOfForm={handleTypeOfForm}
      // isLoading={loading}
      // isSuccess={success}
      createJobPostingPublishIsSuccess={createJobPostingPublishIsSuccess}
      createJobPostingPublishisLoading={createJobPostingPublishisLoading}
      createJobPostingDraftisLoading={createJobPostingDraftisLoading}
    />
  )
}
export default CreateJobAd
